module.exports = __webpack_public_path__ + "static/img/messenger.ad70875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/social/messenger.png
// module id = 3bBh
// module chunks = 31